import { gql } from "urql";
export const PriorityReferralReceivedSubscription = gql `
    subscription PriorityReferralReceived {
        priorityReferralReceived {
            priorityReferralId
            caregiver {
                userId
                firstName
                lastName
                email
                phoneNumber
            }
            patient {
                patientId
                firstName
                lastName
                dateOfBirth
                postalCode
                postalCodeInfo {
                    city
                    stateId
                    postalCode
                }
            }
            therapyCategory {
                therapyCategoryId
                name
            }
            archivedAt
            createdAt
        }
    }
`;
